import { render, staticRenderFns } from "./configureGetLinkTemplate.vue?vue&type=template&id=264916dd&scoped=true"
import script from "./configureGetLinkTemplate.vue?vue&type=script&lang=js"
export * from "./configureGetLinkTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264916dd",
  null
  
)

export default component.exports